import React, { Component } from 'react';
import Content from'./Content';


class Dashboard extends Component{
    render(){
        return <Content />;
    }
}

export default Dashboard;   


// WEBPACK FOOTER //
// ./src/components/Dashboard.js